import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Hero = () => {
  return (
    <section id="top" className="relative pt-32 pb-24 md:pt-44 md:pb-36 overflow-hidden bg-hero-network">
      <div className="container relative">
        <div className="mx-auto max-w-4xl text-center animate-fade-up">
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.08] tracking-tight text-balance">
            Enterprise Software Suite powered by a{" "}
            <span className="text-gradient">High‑Performance Integration Platform</span>
          </h1>

          <h2 className="font-display mt-6 text-xl md:text-[1.75rem] font-medium text-muted-foreground">
            Lightning Fast Products
          </h2>

          <p className="mt-6 text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            A suite of advanced software products powered by a high-performance integration platform and polymorphic AI for real-time monitoring, optimization, and scaling.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Button variant="hero" size="xl" asChild>
              <a href="#contact" data-umami-event="request_demo" data-umami-event-product="home">
                Request Demo <ArrowRight className="ml-2 h-4 w-4" />
              </a>
            </Button>
          </div>
        </div>

        {/* Floating stat card mock */}
        <div className="mt-20 md:mt-28 max-w-5xl mx-auto animate-fade-in" style={{ animationDelay: "0.2s" }}>
          <div className="relative rounded-2xl border-gradient bg-card-gradient p-1 shadow-elevated">
            <div className="rounded-[14px] bg-surface p-6 md:p-8">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
                {[
                  { k: "<5ms", v: "Avg processing" },
                  { k: "99.99%", v: "Uptime SLA" },
                  { k: "1B+", v: "Requests per day" },
                  { k: "24/7", v: "Enterprise support" },
                ].map((s) => (
                  <div key={s.v}>
                    <div className="font-display text-3xl md:text-4xl font-bold text-gradient">{s.k}</div>
                    <div className="mt-1 text-sm text-muted-foreground">{s.v}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <p className="mt-3 text-xs text-muted-foreground text-left italic">
            * Depending on customer infrastructure
          </p>
        </div>
      </div>
    </section>
  );
};
